import Vue from 'vue'
import VueI18n from 'vue-i18n'

const en = require('./lang/en.yaml')
const ja = require('./lang/ja.yaml')

import numberFormats from './format/numberFormats'
import dateTimeFormats from './format/dateTimeFormat'

const messages = {
  en: en,
  ja: ja
}

// set plugin
Vue.use(VueI18n)

export default new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages,
  numberFormats,
  dateTimeFormats
})
